import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CsDeferService {
  // loadCs：@defer 的判斷, 是否要延遲載入 app-customer-service.
  // csOrderId：訂單編號, 可允許為空(消息中心打開).
  // csSessionId：消息中心打開指定對話位置使用.
  // openCs：開啟線上客服服務畫面後, 會改回 false.
  // readSession：消息中心使用, 讓要顯示未讀數量的畫面, 只要注入 CsDeferService, 就可以把未讀數量更新.
  readonly loadCs = signal(false);
  readonly csOrderId = signal('');
  readonly csSessionId = signal('');
  readonly openCs = signal(false);
  readonly readSession = signal(false);

  initCs(orderId: string, sessionId = ''): void {
    this.loadCs.set(true);
    this.csOrderId.set(orderId);
    this.csSessionId.set(sessionId);
    this.openCs.set(true);
  }

  clear(): void {
    this.loadCs.set(false);
    this.csOrderId.set('');
    this.csSessionId.set('');
    this.openCs.set(false);
    this.readSession.set(false);
  }
}
